module.exports = __webpack_public_path__ + "static/image/xxlogo.74b066a1a88d678224b526467e48020e.png";